import styled from "styled-components";

const Section = styled.div`
  margin-bottom: 10px;
`;

const Heading = styled.h2`
  margin-bottom: 10px;
  font-size: 16px;
  letter-spacing: 0px;
`;

export const SectionWithHeading = ({ heading, children }: { heading: string; children: React.ReactNode }) => {
  return (
    <Section>
      <Heading>{heading}</Heading>
      {children}
    </Section>
  );
};
